<template>
  <div class="fleet-station-manage">
    <div class="direction-indicator" :class="arrowDirectionClass">{{ arrowDirectionText }}</div>
    <Row :gutter="16" class="split-layout">
      <Col :span="10">
        <Card title="车队搜索 / 列表" class="panel-card">
          <Form :model="fleetSearch" inline>
            <FormItem>
              <Select
                v-model="fleetSearch.agent_id"
                filterable
                clearable
                placeholder="选择合伙人"
                style="width: 180px"
                @on-change="searchFleets(true)"
              >
                <Option v-for="item in agentOptions" :key="item.id" :value="item.id">{{ item.name }} ({{ item.company_count }})</Option>
              </Select>
            </FormItem>
            <FormItem>
              <Input v-model="fleetSearch.keyword" placeholder="输入车队名称 / ID" @on-enter="searchFleets(true)"></Input>
            </FormItem>
            <FormItem>
              <Button type="primary" @click="searchFleets(true)" :loading="fleetLoading">搜索</Button>
            </FormItem>
            <FormItem v-if="fleetListMode === 'linkedByStation'">
              <DatePicker
                v-model="fleetSearch.schedule_time"
                type="datetime"
                placeholder="请选择预约执行时间"
                style="width: 220px"
              ></DatePicker>
            </FormItem>
            <FormItem v-if="fleetListMode === 'linkedByStation'">
              <Button @click="resetFleetList">返回全部车队</Button>
            </FormItem>
          </Form>

          <div class="panel-tip" v-if="fleetListMode === 'linkedByStation' && selectedStation">
            当前展示：
            <span v-if="selectedAgentName">合伙人 【 {{ selectedAgentName }} 】 下，</span>
            已关联站点 【 {{ selectedStation.gas_name }} 】 的车队
          </div>

          <div class="fleet-action" v-if="selectedStation && fleetListMode === 'linkedByStation'">
            <Button type="primary" size="small" style="margin-right: 8px" @click="openBatchOnlineModal">批量上线该站</Button>
            <Button type="error" size="small" @click="batchOfflineByStation">批量下线该站</Button>
          </div>

          <Table
            ref="fleetTable"
            size="small"
            stripe
            border
            :columns="fleetColumns"
            :data="fleets"
            :loading="fleetLoading"
            @on-selection-change="handleFleetSelectionChange"
          ></Table>

          <Page
            class="table-pager"
            :total="fleetPager.total"
            :current="fleetPager.page"
            :page-size="fleetPager.pagesize"
            :page-size-opts="[20, 50]"
            size="small"
            show-total
            show-sizer
            @on-change="handleFleetPageChange"
            @on-page-size-change="handleFleetPageSizeChange"
          ></Page>
        </Card>
      </Col>

      <Col :span="14">
        <Card title="站点搜索 / 列表" class="panel-card">
          <Form :model="stationSearch" inline>
            <FormItem>
              <Select
                v-model="stationSearch.platform"
                clearable
                placeholder="选择渠道"
                style="width: 180px"
                @on-change="searchStations(true)"
              >
                <Option v-for="item in platformOptions" :key="item" :value="item">{{ item }}</Option>
              </Select>
            </FormItem>
            <FormItem>
              <Input v-model="stationSearch.keyword" placeholder="输入站点名称 / ID" @on-enter="searchStations(true)"></Input>
            </FormItem>
            <FormItem>
              <Button type="primary" @click="searchStations(true)" :loading="stationLoading">搜索</Button>
            </FormItem>
            <FormItem v-if="stationListMode === 'linkedByFleet'">
              <Button @click="resetStationList">返回全部站点</Button>
            </FormItem>
          </Form>

          <div class="panel-tip" v-if="stationListMode === 'linkedByFleet' && selectedFleet">
            当前展示：车队 【 {{ selectedFleet.company_name }} 】 已关联站点
          </div>

          <Table
            size="small"
            stripe
            border
            :columns="stationColumns"
            :data="stations"
            :loading="stationLoading"
            @on-row-click="handleStationSelect"
          ></Table>

          <Page
            class="table-pager"
            :total="stationPager.total"
            :current="stationPager.page"
            :page-size="stationPager.pagesize"
            :page-size-opts="[20, 50]"
            size="small"
            show-total
            show-sizer
            @on-change="handleStationPageChange"
            @on-page-size-change="handleStationPageSizeChange"
          ></Page>
        </Card>
      </Col>
    </Row>

    <Modal
      v-model="batchOnlineModal.visible"
      title="批量上线该站"
      width="980"
      :mask-closable="true"
      @on-visible-change="handleBatchOnlineModalVisibleChange"
    >
      <div class="batch-online-modal" v-if="selectedStation">
        <div class="batch-online-station-title">
          当前站点：{{ selectedStation.gas_name }}（ID：{{ selectedStation.station_id }}）
        </div>
        <Row :gutter="12">
          <Col :span="14">
            <Card dis-hover>
              <div slot="title">可选择车队（左侧筛选）</div>
              <Form :model="batchOnlineModal.search" inline>
                <FormItem>
                  <Select
                    v-model="batchOnlineModal.search.agent_id"
                    filterable
                    clearable
                    placeholder="选择合伙人"
                    style="width: 160px"
                    @on-change="searchBatchOnlineFleets(true)"
                  >
                    <Option v-for="item in agentOptions" :key="item.id" :value="item.id">{{ item.name }} ({{ item.company_count }})</Option>
                  </Select>
                </FormItem>
                <FormItem>
                  <Input
                    v-model="batchOnlineModal.search.keyword"
                    placeholder="输入车队名称 / ID"
                    @on-enter="searchBatchOnlineFleets(true)"
                  ></Input>
                </FormItem>
                <FormItem>
                  <Button type="primary" :loading="batchOnlineModal.loading" @click="searchBatchOnlineFleets(true)">搜索</Button>
                </FormItem>
              </Form>

              <Table
                size="small"
                stripe
                border
                :columns="batchOnlineColumns"
                :data="batchOnlineModal.rows"
                :loading="batchOnlineModal.loading"
                @on-selection-change="handleBatchOnlineSelectionChange"
              ></Table>

              <Page
                class="table-pager"
                :total="batchOnlineModal.pager.total"
                :current="batchOnlineModal.pager.page"
                :page-size="batchOnlineModal.pager.pagesize"
                :page-size-opts="[20, 50]"
                size="small"
                show-total
                show-sizer
                @on-change="handleBatchOnlinePageChange"
                @on-page-size-change="handleBatchOnlinePageSizeChange"
              ></Page>
            </Card>
          </Col>

          <Col :span="10">
            <Card dis-hover>
              <div slot="title">已选车队（右侧实时）</div>
              <div class="batch-online-selected-count">已选 {{ batchOnlineSelectedList.length }} 个</div>
              <div class="batch-online-selected-list" v-if="batchOnlineSelectedList.length > 0">
                <div class="batch-online-selected-item" v-for="item in batchOnlineSelectedList" :key="item.company_id">
                  <span class="selected-name">{{ item.company_name }}</span>
                  <span class="selected-id">ID: {{ item.company_id }}</span>
                  <Button type="text" size="small" @click="removeBatchOnlineSelected(item.company_id)">移除</Button>
                </div>
              </div>
              <div class="batch-online-empty" v-else>请在左侧勾选要上线的车队</div>
            </Card>
          </Col>
        </Row>
      </div>
      <div slot="footer">
        <Button @click="batchOnlineModal.visible = false">取消</Button>
        <Button type="primary" :loading="batchOnlineModal.submitting" @click="submitBatchOnlineByStation">确认上线</Button>
      </div>
    </Modal>

  </div>
</template>

<script>
export default {
  name: 'fleetStationManage',
  data() {
    return {
      fleetSearch: {
        agent_id: '',
        keyword: '',
        schedule_time: ''
      },
      stationSearch: {
        platform: '',
        keyword: ''
      },
      agentOptions: [],
      platformOptions: ['卡世通', '车福通', '卓壹', '秒加', '合力团气', '畅油', '运达通', '小鲸', '三桶油', '燕宝', '中交车旺', '大车队长', '瑞源海泓', '鑫恒源', '驾油吧'],
      fleets: [],
      stations: [],
      selectedFleet: null,
      selectedStation: null,
      selectedFleetIds: [],
      fleetLoading: false,
      stationLoading: false,
      arrowDirection: '',
      fleetListMode: 'all',
      stationListMode: 'all',
      fleetPager: {
        page: 1,
        pagesize: 20,
        total: 0
      },
      stationPager: {
        page: 1,
        pagesize: 20,
        total: 0
      },
      batchOnlineModal: {
        visible: false,
        loading: false,
        submitting: false,
        search: {
          agent_id: '',
          keyword: ''
        },
        rows: [],
        pager: {
          page: 1,
          pagesize: 20,
          total: 0
        },
        selectedMap: {}
      },
      baseFleetColumns: [
        {
          type: 'selection',
          width: 45,
          align: 'center'
        },
        {
          title: '车队ID',
          key: 'company_id',
          width: 90,
          render: (h, params) => h('a', {
            on: {
              click: () => this.handleFleetSelect(params.row)
            }
          }, params.row.company_id)
        },
        {
          title: '车队名称',
          key: 'company_name',
          minWidth: 200,
          render: (h, params) => h('a', {
            on: {
              click: () => this.handleFleetSelect(params.row)
            }
          }, params.row.company_name)
        }
      ]
    };
  },
  computed: {
    selectedAgentName() {
      const selectedId = Number(this.fleetSearch.agent_id || 0);
      if (!selectedId) return '';
      const target = (this.agentOptions || []).find((item) => Number(item.id) === selectedId);
      return target ? target.name : '';
    },
    arrowDirectionText() {
      if (this.arrowDirection === 'right') {
        return '==>';
      }
      if (this.arrowDirection === 'left') {
        return '<==';
      }
      return '';
    },
    arrowDirectionClass() {
      return {
        'to-right': this.arrowDirection === 'right',
        'to-left': this.arrowDirection === 'left',
        hide: !this.arrowDirection
      };
    },
    fleetColumns() {
      const cols = [...this.baseFleetColumns];
      if (this.fleetListMode === 'all') {
        cols.push(
          {
            title: '负责人',
            key: 'manager_name',
            width: 110
          },
          {
            title: '站点数',
            key: 'station_count',
            width: 90
          }
        );
      } else {
        cols.push(
          {
            title: '车队价格',
            key: 'edit_company_price',
            width: 130,
            render: (h, params) => h('Input', {
              props: {
                value: params.row.edit_company_price !== undefined ? String(params.row.edit_company_price) : '',
                size: 'small',
                placeholder: '车队价格'
              },
              style: {
                width: '110px'
              },
              on: {
                input: (val) => {
                  this.fleets[params.index].edit_company_price = this.sanitizeNumericText(val, false);
                },
                'on-blur': () => {
                  const v = this.fleets[params.index].edit_company_price;
                  this.fleets[params.index].edit_company_price = this.formatMoneyInput(v, false);
                }
              }
            })
          },
          // {
          //   title: '零售价',
          //   key: 'retail_prices',
          //   width: 100
          // },
          {
            title: '操作',
            width: 240,
            align: 'center',
            render: (h, params) => {
              const btns = [
                h('Button', {
                props: {
                  size: 'small',
                  type: 'warning'
                },
                on: {
                  click: () => this.scheduleAdjust(params.row)
                }
              }, '定时调价'),
                h('Button', {
                style: {
                  marginLeft: '6px'
                },
                props: {
                  size: 'small',
                  type: 'primary'
                },
                on: {
                  click: () => this.immediateAdjust(params.row)
                }
              }, '立即调整')
              ];

              if (this.hasPendingSchedule(params.row)) {
                btns.push(
                  h('Poptip', {
                    props: {
                      trigger: 'hover',
                      placement: 'top',
                      transfer: true
                    },
                    style: {
                      marginLeft: '6px'
                    }
                  }, [
                    h('div', { slot: 'content' }, [
                      h('p', `执行时间：${params.row.fixed_time || ''}`),
                      h('p', `原车队价：${Number(params.row.company_price || 0).toFixed(2)}`),
                      h('p', `新车队价：${Number(params.row.new_company_price || 0).toFixed(2)}`)
                    ]),
                    h('Icon', {
                      props: {
                        type: 'ios-alert',
                        color: '#ff9900',
                        size: 18
                      }
                    })
                  ])
                );
              }

              return h('div', btns);
            }
          }
        );
      }
      return cols;
    },
    stationColumns() {
      const isLinkedByFleet = this.stationListMode === 'linkedByFleet';
      const dynamicCostTitle = isLinkedByFleet
        ? (Number(this.stations[0] && this.stations[0].company_is_bill) === 1 ? '成本A' : '成本B')
        : '站点成本';
      const cols = [
        {
          title: '站点ID',
          key: 'station_id',
          width: 80
        },
        {
          title: '站点名称',
          key: 'gas_name',
          minWidth: 220
        },
        {
          title: '渠道',
          key: 'platform',
          width: 120
        },
        {
          title: '油机价',
          key: 'station_price',
          width: 80
        },
        {
          title: '挂牌价',
          key: 'ndrc_price',
          width: 80
        },
        {
          title: dynamicCostTitle,
          key: 'station_cost',
          width: 80,
          render: (h, params) => {
            const companyIsBill = Number(params.row.company_is_bill || 0);
            const priceA = Number(params.row.price2 || 0);
            const priceB = Number(params.row.no_bill_price || 0);
            if (!isLinkedByFleet) {
              return h('div', [
                h('div', `A: ${priceA.toFixed(2)}`),
                h('div', `B: ${priceB.toFixed(2)}`)
              ]);
            }
            let cost = Number(params.row.station_cost);
            if (Number.isNaN(cost)) {
              cost = companyIsBill === 1 ? priceA : priceB;
            }
            return h('span', cost.toFixed(2));
          }
        },
        
      ];

      if (this.stationListMode === 'linkedByFleet') {
        cols.push({
          title: '车队价',
          key: 'company_price',
          width: 100
        });
        cols.push({
          title: '差价',
          key: 'spread_price',
          width: 80,
          render: (h, params) => {
            const spread = Number(params.row.spread_price || 0);
            return h('span', {
              style: {
                color: spread < 0 ? '#ed4014' : spread == 0 ? 'orange' : '#1e962c'
              }
            }, spread.toFixed(2));
          }
        });
      }
      return cols;
    },
    batchOnlineSelectedList() {
      const list = Object.values(this.batchOnlineModal.selectedMap || {});
      list.sort((a, b) => Number(a.company_id || 0) - Number(b.company_id || 0));
      return list;
    },
    batchOnlineColumns() {
      return [
        {
          type: 'selection',
          width: 45,
          align: 'center'
        },
        {
          title: '车队ID',
          key: 'company_id',
          width: 95
        },
        {
          title: '车队名称',
          key: 'company_name',
          minWidth: 180
        },
        {
          title: '负责人',
          key: 'manager_name',
          width: 100
        },
        {
          title: '关联状态',
          key: 'is_linked_text',
          width: 100,
          render: (h, params) => {
            const isLinked = Number(params.row.is_linked || 0) === 1;
            return h('span', {
              style: {
                color: isLinked ? '#19be6b' : '#666'
              }
            }, isLinked ? '已关联' : '未关联');
          }
        }
      ];
    }
  },
  methods: {
    sanitizeNumericText(val, allowNegative = false) {
      let text = val === undefined || val === null ? '' : String(val);
      text = text.replace(allowNegative ? /[^\d.\-]/g : /[^\d.]/g, '');
      if (allowNegative) {
        text = text.replace(/(?!^)-/g, '');
      }
      const parts = text.split('.');
      if (parts.length > 2) {
        text = `${parts.shift()}.${parts.join('')}`;
      }
      if (text.startsWith('.')) text = `0${text}`;
      if (text.startsWith('-.')) text = text.replace('-.', '-0.');
      return text;
    },
    formatMoneyInput(val, allowNegative = false) {
      const text = this.sanitizeNumericText(val, allowNegative);
      if (!text) return '';
      const num = Number(text);
      if (Number.isNaN(num)) {
        this.$Message.warning('请输入数字金额');
        return '';
      }
      return num.toFixed(2);
    },
    async searchFleets(resetPage = false) {
      if (resetPage) {
        this.fleetPager.page = 1;
      }
      this.fleetLoading = true;
      this.selectedFleetIds = [];
      this.clearFleetSelection();
      try {
        if (this.fleetListMode === 'linkedByStation' && this.selectedStation) {
          const res = await this.$commonFun.postProxy('admin/company/getStationCompanyRelationList', {
            station_id: this.selectedStation.station_id,
            linked_only: 1,
            agent_id: this.fleetSearch.agent_id || '',
            keyword: this.fleetSearch.keyword,
            page: this.fleetPager.page,
            pagesize: this.fleetPager.pagesize
          });
          this.$commonFun.dealApiResult(res, (result) => {
            this.fleets = (result.data || []).map((item) => ({
              ...item,
              edit_company_price: Number(item.company_price || 0)
            }));
            this.fleetPager.total = Number(result.count || 0);
          });
          return;
        }

        const res = await this.$commonFun.postProxy('admin/company/getCompanyStationManageCompanies', {
          agent_id: this.fleetSearch.agent_id || '',
          keyword: this.fleetSearch.keyword,
          page: this.fleetPager.page,
          pagesize: this.fleetPager.pagesize
        });
        this.$commonFun.dealApiResult(res, (result) => {
          this.fleets = result.data || [];
          this.fleetPager.total = Number(result.count || 0);
        });
      } finally {
        this.fleetLoading = false;
      }
    },
    async searchStations(resetPage = false) {
      if (resetPage) {
        this.stationPager.page = 1;
      }
      this.stationLoading = true;
      try {
        if (this.stationListMode === 'linkedByFleet' && this.selectedFleet) {
          const res = await this.$commonFun.postProxy('admin/company/getCompanyStationRelationList', {
            company_id: this.selectedFleet.company_id,
            linked_only: 1,
            platform: this.stationSearch.platform || '',
            keyword: this.stationSearch.keyword,
            page: this.stationPager.page,
            pagesize: this.stationPager.pagesize
          });
          this.$commonFun.dealApiResult(res, (result) => {
            const stationList = (result.data || []).map((item) => {
              const companyPrice = Number(item.company_price || 0);
              const companyIsBill = Number(item.company_is_bill || 0);
              const stationCost = companyIsBill === 1 ? Number(item.price2 || 0) : Number(item.no_bill_price || 0);
              return {
                ...item,
                station_cost: stationCost,
                spread_price: companyPrice - stationCost
              };
            });
            stationList.sort((a, b) => {
              const aNeg = Number(a.spread_price || 0) < 0 ? 1 : 0;
              const bNeg = Number(b.spread_price || 0) < 0 ? 1 : 0;
              if (aNeg !== bNeg) return bNeg - aNeg;
              return 0;
            });
            this.stations = stationList;
            this.stationPager.total = Number(result.count || 0);
          });
          return;
        }

        const res = await this.$commonFun.postProxy('admin/company/getCompanyStationManageStations', {
          platform: this.stationSearch.platform || '',
          keyword: this.stationSearch.keyword,
          page: this.stationPager.page,
          pagesize: this.stationPager.pagesize
        });
        this.$commonFun.dealApiResult(res, (result) => {
          this.stations = result.data || [];
          this.stationPager.total = Number(result.count || 0);
        });
      } finally {
        this.stationLoading = false;
      }
    },
    async handleFleetSelect(row) {
      if (!row || !row.company_id) return;
      this.selectedFleet = row;
      this.arrowDirection = 'right';
      this.stationListMode = 'linkedByFleet';
      this.stationPager.page = 1;
      await this.searchStations();
    },
    async handleStationSelect(row) {
      if (!row || !row.station_id) return;
      this.selectedStation = row;
      this.arrowDirection = 'left';
      this.fleetListMode = 'linkedByStation';
      this.fleetPager.page = 1;
      await this.searchFleets();
    },
    handleFleetSelectionChange(selection) {
      this.selectedFleetIds = (selection || []).map((item) => Number(item.company_id));
    },
    async loadAgentOptions() {
      const res = await this.$commonFun.postProxy('admin/company/getAgentSelect', {
        keyword: ''
      });
      this.$commonFun.dealApiResult(res, (result) => {
        this.agentOptions = result.data || [];
      });
    },
    async immediateAdjust(row) {
      if (!this.selectedStation) {
        return this.$commonFun.errorTip('请先选择一个站点');
      }
      const price = Number(row.edit_company_price || 0);
      if (price <= 0) {
        return this.$commonFun.errorTip('车队价格必须大于0');
      }
      const res = await this.$commonFun.postProxy('admin/company/editCompanyStationPrice', {
        company_id: row.company_id,
        station_id: this.selectedStation.station_id,
        price
      });
      this.$commonFun.dealApiResult(res, async () => {
        this.$commonFun.successTip(res.msg || '价格修改成功');
        await this.searchFleets();
      });
    },
    async scheduleAdjust(row) {
      if (!this.selectedStation) {
        return this.$commonFun.errorTip('请先选择一个站点');
      }
      if (!row || Number(row.company_id || 0) <= 0) {
        return this.$commonFun.errorTip('车队参数错误');
      }
      if (!this.fleetSearch.schedule_time) {
        return this.$commonFun.errorTip('请选择执行时间');
      }
      const price = Number(row.edit_company_price || 0);
      if (price <= 0) {
        return this.$commonFun.errorTip('车队价格必须大于0');
      }

      const doTime = typeof this.fleetSearch.schedule_time === 'string'
        ? this.fleetSearch.schedule_time
        : this.formatDateTime(this.fleetSearch.schedule_time);
      if (!doTime) {
        return this.$commonFun.errorTip('执行时间格式错误');
      }

      const res = await this.$commonFun.postProxy('admin/company/multiEditCompanyStationPrice', {
        company_id: Number(row.company_id || 0),
        do_time: doTime,
        prices: [
          {
            station_id: this.selectedStation.station_id,
            new_company_price: price
          }
        ]
      });

      this.$commonFun.dealApiResult(res, async () => {
        this.$commonFun.successTip(res.msg || '预约成功');
        await this.searchFleets();
      });
    },
    hasPendingSchedule(row) {
      if (!row) return false;
      const timeText = row.fixed_time || '';
      if (!timeText) return false;
      const nextPrice = Number(row.new_company_price || 0);
      if (nextPrice <= 0) return false;
      return Date.parse(timeText.replace(/-/g, '/')) > Date.now();
    },
    formatDateTime(dateObj) {
      if (!dateObj) return '';
      const d = new Date(dateObj);
      if (Number.isNaN(d.getTime())) return '';
      const pad = (num) => (num < 10 ? `0${num}` : `${num}`);
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    async batchOfflineByStation() {
      if (!this.selectedStation) {
        return this.$commonFun.errorTip('请先选择一个站点');
      }
      if (this.selectedFleetIds.length <= 0) {
        return this.$commonFun.errorTip('请先勾选至少一个车队');
      }

      const res = await this.$commonFun.postProxy('admin/company/batchEditCompanyStationManage', {
        company_ids: this.selectedFleetIds,
        station_ids: [this.selectedStation.station_id],
        action: 'offline'
      });
      this.$commonFun.dealApiResult(res, async () => {
        this.$commonFun.successTip(res.msg || '批量下线成功');
        this.selectedFleetIds = [];
        this.clearFleetSelection();
        await this.searchFleets();
        if (this.selectedFleet && this.stationListMode === 'linkedByFleet') {
          await this.searchStations();
        }
      });
    },
    openBatchOnlineModal() {
      if (!this.selectedStation) {
        return this.$commonFun.errorTip('请先选择一个站点');
      }
      this.batchOnlineModal.search.agent_id = this.fleetSearch.agent_id || '';
      this.batchOnlineModal.search.keyword = '';
      this.batchOnlineModal.pager.page = 1;
      this.batchOnlineModal.selectedMap = {};
      this.batchOnlineModal.rows = [];
      this.batchOnlineModal.visible = true;
      this.searchBatchOnlineFleets(true);
    },
    handleBatchOnlineModalVisibleChange(visible) {
      if (!visible) {
        this.batchOnlineModal.loading = false;
        this.batchOnlineModal.submitting = false;
      }
    },
    async searchBatchOnlineFleets(resetPage = false) {
      if (!this.selectedStation) return;
      if (resetPage) {
        this.batchOnlineModal.pager.page = 1;
      }
      this.batchOnlineModal.loading = true;
      try {
        const res = await this.$commonFun.postProxy('admin/company/getStationCompanyRelationList', {
          station_id: this.selectedStation.station_id,
          linked_only: 0,
          agent_id: this.batchOnlineModal.search.agent_id || '',
          keyword: this.batchOnlineModal.search.keyword,
          page: this.batchOnlineModal.pager.page,
          pagesize: this.batchOnlineModal.pager.pagesize
        });
        this.$commonFun.dealApiResult(res, (result) => {
          const selectedMap = this.batchOnlineModal.selectedMap || {};
          const rows = (result.data || []).map((item) => {
            const id = Number(item.company_id || 0);
            const isLinked = Number(item.is_linked || 0) === 1;
            return {
              ...item,
              _disabled: isLinked,
              _checked: !isLinked && !!selectedMap[id]
            };
          });
          this.batchOnlineModal.rows = rows;
          this.batchOnlineModal.pager.total = Number(result.count || 0);
        });
      } finally {
        this.batchOnlineModal.loading = false;
      }
    },
    handleBatchOnlineSelectionChange(selection) {
      const map = { ...(this.batchOnlineModal.selectedMap || {}) };
      const pageSelectableIds = (this.batchOnlineModal.rows || [])
        .filter((row) => !row._disabled)
        .map((row) => Number(row.company_id || 0));
      pageSelectableIds.forEach((id) => {
        delete map[id];
      });
      (selection || []).forEach((item) => {
        const id = Number(item.company_id || 0);
        if (!id) return;
        map[id] = {
          company_id: id,
          company_name: item.company_name || '',
          manager_name: item.manager_name || ''
        };
      });
      this.batchOnlineModal.selectedMap = map;
    },
    removeBatchOnlineSelected(companyId) {
      const id = Number(companyId || 0);
      if (!id) return;
      const map = { ...(this.batchOnlineModal.selectedMap || {}) };
      delete map[id];
      this.batchOnlineModal.selectedMap = map;
      this.batchOnlineModal.rows = (this.batchOnlineModal.rows || []).map((row) => {
        if (Number(row.company_id || 0) === id) {
          return {
            ...row,
            _checked: false
          };
        }
        return row;
      });
    },
    handleBatchOnlinePageChange(page) {
      this.batchOnlineModal.pager.page = page;
      this.searchBatchOnlineFleets();
    },
    handleBatchOnlinePageSizeChange(size) {
      this.batchOnlineModal.pager.pagesize = size;
      this.batchOnlineModal.pager.page = 1;
      this.searchBatchOnlineFleets();
    },
    async submitBatchOnlineByStation() {
      if (!this.selectedStation) {
        return this.$commonFun.errorTip('请先选择一个站点');
      }
      const companyIds = this.batchOnlineSelectedList.map((item) => Number(item.company_id || 0)).filter((id) => id > 0);
      if (companyIds.length <= 0) {
        return this.$commonFun.errorTip('请先选择至少一个车队');
      }
      this.batchOnlineModal.submitting = true;
      try {
        const res = await this.$commonFun.postProxy('admin/company/batchEditCompanyStationManage', {
          company_ids: companyIds,
          station_ids: [this.selectedStation.station_id],
          action: 'online'
        });
        this.$commonFun.dealApiResult(res, async () => {
          this.$commonFun.successTip(res.msg || '批量上线成功');
          this.batchOnlineModal.visible = false;
          this.batchOnlineModal.selectedMap = {};
          if (this.fleetListMode === 'linkedByStation') {
            await this.searchFleets();
          }
          if (this.selectedFleet && this.stationListMode === 'linkedByFleet') {
            await this.searchStations();
          }
        });
      } finally {
        this.batchOnlineModal.submitting = false;
      }
    },
    resetFleetList() {
      this.fleetListMode = 'all';
      this.fleetSearch.agent_id = '';
      this.fleetSearch.keyword = '';
      this.fleetPager.page = 1;
      this.searchFleets();
    },
    resetStationList() {
      this.stationListMode = 'all';
      this.stationSearch.platform = '';
      this.stationSearch.keyword = '';
      this.stationPager.page = 1;
      this.searchStations();
    },
    handleFleetPageChange(page) {
      this.fleetPager.page = page;
      this.searchFleets();
    },
    handleFleetPageSizeChange(size) {
      this.fleetPager.pagesize = size;
      this.fleetPager.page = 1;
      this.searchFleets();
    },
    handleStationPageChange(page) {
      this.stationPager.page = page;
      this.searchStations();
    },
    handleStationPageSizeChange(size) {
      this.stationPager.pagesize = size;
      this.stationPager.page = 1;
      this.searchStations();
    },
    clearFleetSelection() {
      if (this.$refs.fleetTable && typeof this.$refs.fleetTable.clearSelection === 'function') {
        this.$refs.fleetTable.clearSelection();
      }
    }
  },
  mounted() {
    this.loadAgentOptions();
    this.searchFleets(true);
  }
};
</script>

<style scoped lang="less">
.fleet-station-manage {
  position: relative;

  .split-layout {
    position: relative;
  }

  .panel-card {
    min-height: 820px;
  }

  .panel-tip {
    margin-bottom: 10px;
    color: #666;
    font-size: 16px;
  }

  .fleet-action {
    margin-bottom: 10px;
    text-align: right;
  }

  .batch-online-modal {
    .batch-online-station-title {
      margin-bottom: 12px;
      color: #333;
      font-size: 14px;
      font-weight: 600;
    }

    .batch-online-selected-count {
      margin-bottom: 10px;
      color: #666;
      font-size: 13px;
    }

    .batch-online-selected-list {
      min-height: 380px;
      max-height: 540px;
      overflow-y: auto;
      border: 1px solid #eee;
      border-radius: 4px;
      padding: 8px;
      background: #fafafa;
    }

    .batch-online-selected-item {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #efefef;
      padding: 6px 0;

      .selected-name {
        flex: 1;
        color: #333;
      }

      .selected-id {
        width: 92px;
        color: #888;
        text-align: right;
        margin-right: 6px;
      }
    }

    .batch-online-empty {
      min-height: 120px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #999;
      border: 1px dashed #ddd;
      border-radius: 4px;
      background: #fafafa;
    }
  }

  .table-pager {
    margin-top: 12px;
    text-align: right;
  }

  .direction-indicator {
    position: absolute;
    top: 100px;
    left: 41.5%;
    transform: translateX(-50%);
    z-index: 5;
    font-size: 20px;
    font-weight: 700;
    color: #1e962c;
    background: #fff;
    padding: 2px 8px;
    border-radius: 4px;
    border: 1px solid #d9ecff;
  }

  .direction-indicator.hide {
    display: none;
  }

  .direction-indicator.to-right,
  .direction-indicator.to-left {
    display: inline-block;
  }
}
</style>
